module.exports = __webpack_public_path__ + "static/media/citizenry.400883cc.svg";